import 'bootstrap-daterangepicker';
import moment from 'moment';

/*
  Find all possible options here
  http://www.daterangepicker.com/#options
 */

class DatePicker {
  static get defaults () {
    let startDate = moment().startOf('month').toDate(); // start date needs to be Date type
    let endDate = moment();
    return {
      locale: {
        format: 'YYYY-MM-DD',
      },
      startDate: startDate,
      endDate: endDate,
      singleDatePicker: true,
      opens: 'left',
      applyClass: 'btn btn-primary',
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment()],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
    };
  }

  constructor ({selector = '.date-range', options = {}, isFilter = false} = {}) {
    this.isFilter = isFilter;
    this.$element = $(selector);
    this.initPicker(options);
  }

  static getOptions (options) {
    return $.extend(DatePicker.defaults, options);
  }

  initPicker (customOptions) {
    let options = DatePicker.getOptions(customOptions);
    $(() => {
      if (this.isFilter) {
        options.locale.cancelLabel = 'Clear';
        this.$element.daterangepicker(options);

        this.$element.val(this.$element.attr('value'));
        this.$element.on('cancel.daterangepicker', () => {
          this.$element.val('');
        });
      } else {
        this.$element.daterangepicker(options);
      }
    });
  }
}

class DateRangePicker extends DatePicker {
  constructor ({selector = '.date-range', options = {}, isFilter = false} = {}) {
    options.singleDatePicker = false;
    super({selector, options, isFilter});
  }
}

export {DatePicker, DateRangePicker};
